import { render } from "./VideoAdvList.vue?vue&type=template&id=571939f1"
import script from "./VideoAdvList.vue?vue&type=script&lang=js"
export * from "./VideoAdvList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__